import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Table from "./common/table";
import axios from "axios";
import { toast } from "react-toastify";

const $ = require("jquery");
$.DataTable = require("datatables.net");

const toggle_status = async (id) => {
  await axios.post(`/debits/approve_debit/${id}`).then((resp) => {
    toast(resp.data.message);
    window.location.reload(false);
  });
};

const toggle_status_formatter = (id) => {
  return (
    <Link to="#" onClick={() => toggle_status(id)} className="">
      {" "}
      approve
    </Link>
  );
};

class DebitsTable extends Component {
  columns = [
    {
      path: "user",
      label: "By:",
      content: (debit) => debit.user,
    },
    { path: "amount", label: "Amount:" },
    { path: "bankName", label: "Bank:" },
    { path: "accountNumber", label: "Account No:" },
    { path: "accountName", label: "Account Name:" },
    { path: "order_ref", label: "Order Ref" },
    { path: "status", label: "Status" },
    {
      path: "transaction_date",
      label: "Txn Date",
      content: (debit) =>
        moment(debit.transaction_date)
          //   .startOf("day")
          .format("DD MM YYYY hh:mm"),
    },
    {
      key: (debit) => debit._id,
      label: "Actions",
      content: (debit) => toggle_status_formatter(debit._id),
    },
  ];

  componentDidMount() {
    $(document).ready(function () {
      $("#dataTable").DataTable();
    });
  }

  render() {
    const { debits, message } = this.props;
    return <Table columns={this.columns} data={debits} message={message} />;
  }
}

export default DebitsTable;
